import VLibras from './VLibras';

export default VLibras;
